<div class="bn-not-found">
  <div class="bn-not-found__container">
    <img
      alt="Not found"
      class="bn-not-found__container__image"
      src="/assets/web-ui/images/bunny-repair-bot.svg"
      [ngStyle]="{
        'width.px': 521,
      }" />
    <div class="bn-not-found__container__title">404 Page not found</div>
    <div class="bn-not-found__container__description">Sorry we were not able to find the page you were looking for</div>
    <bn-web-ui-button
      itemStyle="secondary"
      routerLink="/"
      size="lg">
      Go to Overview
    </bn-web-ui-button>
  </div>
</div>
